// FORM BUILDER ACTIONS:
export const IMPORT_STAGE_STEP = "IMPORT_STAGE_STEP";
export const SET_PROCESS_ID = "SET_PROCESS_ID";
export const FINISH_STAGE2_STEP = "FINISH_STAGE2_STEP";
export const PREVIOUS_WIZARD = "PREVIOUS_WIZARD";
export const SET_PROCESS_FILE_NAME = "SET_PROCESS_FILE_NAME";
export const HANDLE_PROGRESS_WINDOW = "HANDLE_PROGRESS_WINDOW";
export const SET_UNIQUE_ID = "SET_UNIQUE_ID";
export const SET_PROCESS_TYPE = "SET_PROCESS_TYPE";